import { Helmet } from "react-helmet";
import img from "../images/a_qui.png";
const ReviewSection = () => {
  return (
    <>
      <Helmet>
        <title>
          Location d’espaces événementiels et salles chez particuliers et professionnels — Paris, Île-de-France et
          partout en France | Event To Bee
        </title>
        <meta
          name="description"
          content="Louez des espaces événementiels et salles chez des particuliers et professionnels, à Paris, en Île-de-France et partout en France. Trouvez le lieu idéal pour tous vos événements."
          title="On simplifie la location de salles en Île de France. Trouvez le lieu idéal pour votre événement privé ou professionnel. Réservez facilement sur Event To Bee."
        />
      </Helmet>
    </>
  );
};

export default ReviewSection;
